import { Injectable } from '@angular/core';
import { RpcClientService } from './rpc-client.service';
import * as $ from 'jquery';
import { ApifirstService } from './apifirst.service';
import * as environmentUrl from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FdtScriptImporterService {
  public baseUrl = environmentUrl.environment.baseUrl;
  public pageUrl = environmentUrl.environment.pageUrl;
  bootsTrapLoadingDef = $.Deferred();
  bootsTrapFDTDef = $.Deferred();

  // refer js files from web/js/FDT-EU - including this service class.
  // right now refering web/sbdows/js/gfdrs
  extScripts = ["/assets/js/jquery-ui-1.10.3/jquery-ui.min.js",
    // "/assets/js/jquery.treeTable.js",
    "/assets/js/jquery.cookie.js",
    // "/assets/js/sbdows_jquery.messageProvider.js", -- used below one
    "/assets/js/jquery.messageProvider.js",
    "/assets/js/jquery.treeTable.js"// -- web/js/FDT-EU 
    // "/assets/sbdows/js/gfdrs/sbdows_jquery.messageProvider.js"
  ];

  angularInputClass = ".modal .modal-dialog .input-group input.form-control";

  // ??? - check later
  // $SBDOWS('#fdtPlaceholder').append('<div id="applicationStatusDiv"></div>');

  // statusDiv = $SBDOWS("<div>").addClass("head-spinner").txt('fdt.connection.state.progress.short');
  // $SBDOWS('#applicationStatusDiv').append(statusDiv);

  constructor(
    private rpcClientService: RpcClientService, private apiService: ApifirstService
  ) { }


  scriptLoader(params: any) {
    var promiseObj = this.rpcClientService.initializeWebSocket();

    promiseObj.progress((connectionState: any) => {

      if (connectionState === this.rpcClientService.connectionStatus.CONNECTED) {
        this.bootsTrapFDTDef.resolve();
        //reset the div
        //$SBDOWS('#AnalyseLogcontent').html(''); ???        
        console.log("FDT connected, logging in...");

        this.rpcClientService.deferredloginState.then(() => {
          var that = this;
          console.log("FDT loggedin, bootstraping the scripts now");

          this.rpcClientService.bootstrap((resp: any) => {
            if (resp.status === that.rpcClientService.status.SUCCESS) {
              console.log('success bootstrap script response');
              var scriptsToLoad = resp.responseData.result;
              that.insertExtScripts(scriptsToLoad, this.extScripts);

              that.loadScripts(scriptsToLoad, 0, this.rpcClientService, promiseObj, params);
              this.showFDRSIndicator();
              if (params == 'startup') {
                this.apiService.isFDRSConnection.next(true)
              }
            }
            else {
              // console.error("could not bootstrap scripts reason: " +
              //   resp.responseData.errorCode + ":" + resp.responseData.errorMsg);
              this.bootsTrapLoadingDef.reject();
            }
          });
        },
          () => {
            console.log('rejected');
            // removeStatusIcon();  ???
          },
          (code: any, message: any) => {
            console.log("FDT loggedin, but currently is stalled.");
            // showInactiveStatusIcon(message);               ???
          });
      }
      else if (connectionState === this.rpcClientService.connectionStatus.FAILED
        || connectionState === this.rpcClientService.connectionStatus.INCOMPATIBLE) {
        //$SBDOWS('#applicationStatusDiv').empty();  ???
        if (localStorage.getItem("component") == 'fromStartup') {
          this.apiService.freshWebSocketConnStatusonStartUpComp.next('false')
        } else if (localStorage.getItem("component") == 'fromDiagnostic' || localStorage.getItem("component") == 'fromRepair' || localStorage.getItem("component") == 'fromPostRepair' ) {
          this.apiService.getFDRSStatusInDiagnostic.next('false')
        } else {
          this.apiService.freshWebSocketConnStatus.next('false')  
        }
        this.bootsTrapFDTDef.reject();
      }

    });
  }

  showFDRSIndicator() {
    this.apiService.fdrsConnectionIndicator.next('show');
    this.apiService.isShowFDRSLoader.next(false);
  }


  // Load scripts and once DOM is ready with all scripts resolve the bootsTrapLoadingDef promise.
  loadScripts(scriptsToLoad: any, loadedScriptCount: any, rpcClientService: RpcClientService, promiseObj: any, params: any) {
    if (loadedScriptCount === scriptsToLoad.length) {
      if (localStorage.getItem("component") == 'fromStartup') {
        this.apiService.freshWebSocketConnStatusonStartUpComp.next('true')
      } else if (localStorage.getItem("component") == 'fromDiagnostic' || localStorage.getItem("component") == 'fromRepair' || localStorage.getItem("component") == 'fromPostRepair' ) {
        this.apiService.getFDRSStatusInDiagnostic.next('true')
      } else {
        this.apiService.freshWebSocketConnStatus.next('true')
      }
      this.bootsTrapLoadingDef.resolve(rpcClientService, promiseObj);
      if (params) {
        //rpcClientService.startApplication(params); ??? - check when we receive params
      }
      return;
    }

    else if (scriptsToLoad[loadedScriptCount] != undefined) {
      // ???
      var js = document.createElement("script");
      js.type = "text/javascript";

      if (!(scriptsToLoad[loadedScriptCount].startsWith("http://")
        || scriptsToLoad[loadedScriptCount].startsWith("https://"))) {
        //js.src = EtisSbdoWebService.baseUrl + scriptsToLoad[loadedScriptCount];
        // js.src = this.baseUrl + scriptsToLoad[loadedScriptCount];
        //  js.src = 'https://sbdo-dashboard-service-qa.apps.pp01i.edc1.cf.ford.com' + scriptsToLoad[loadedScriptCount];
        js.src = this.pageUrl + scriptsToLoad[loadedScriptCount];
        // ??? 
      }
      else {
        js.src = scriptsToLoad[loadedScriptCount];
      }

      js.async = true;
      (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(js);

      js.onload = () => {
        //console.log(scriptsToLoad[loadedScriptCount] + " loaded");
        this.loadScripts(scriptsToLoad, loadedScriptCount + 1, this.rpcClientService, promiseObj, params);
      };

      // ??? - need to modify and use above logic later
      // console.log( scriptsToLoad[loadedScriptCount]+" loaded" );
      // this.loadScripts(scriptsToLoad, loadedScriptCount+1, rpcClientService, promiseObj, params);

    }
  }

  insertExtScripts(scriptsToLoad: any, extScripts: any) {
    var startScript = scriptsToLoad.filter((script: any) => {
      return script.match(/.*jquery.*/) != null;
    });

    var startScriptPos = startScript.length > 0 ? scriptsToLoad.indexOf(startScript[0]) : scriptsToLoad.length - 1;

    extScripts.forEach((extScript: any) => {
      scriptsToLoad.splice(++startScriptPos, 0, extScript);
    });
  }



}
